import { InstancedBufferAttribute, type BufferGeometry } from 'three';
import { hexToLinear } from '../../core/color';
import type { Vec3 } from '../../geo/types';
import { SURFACE, edgeIdFor, type SurfaceKind } from '../mesh/attributes';
import { createMeshBuilder } from '../mesh/meshBuilder';

export interface StreetTriangle {
  readonly points: readonly (readonly number[])[];
  readonly color: string;
}
export function streetAssetGeometry(
  triangles: readonly StreetTriangle[],
  surface: SurfaceKind = SURFACE.cloth
): BufferGeometry {
  const builder = createMeshBuilder();
  for (const triangle of triangles)
    builder.polygon(
      { color: hexToLinear(triangle.color), surface, edgeId: 0, extent: [1, 1], strokeAngle: 0 },
      { origin: [0, 0, 0], yaw: 0 },
      triangle.points as readonly Vec3[]
    );
  return builder.build();
}
export function streetInstances(geometry: BufferGeometry, count: number, seed: number): void {
  geometry.setAttribute(
    'aInstanceEdgeId',
    new InstancedBufferAttribute(
      Float32Array.from({ length: count }, (_, i) => edgeIdFor(seed + i)),
      1
    )
  );
  geometry.setAttribute(
    'aPainterScale',
    new InstancedBufferAttribute(new Float32Array(count * 2).fill(1), 2)
  );
}
export function mirroredStreetGeometry(geometry: BufferGeometry): BufferGeometry {
  const mirrored = geometry.clone().scale(1, 1, -1),
    index = mirrored.index!;
  for (let i = 0; i < index.count; i += 3) {
    const b = index.getX(i + 1);
    index.setX(i + 1, index.getX(i + 2));
    index.setX(i + 2, b);
  }
  return mirrored;
}
